import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Modal from "./components/modal/Modal";

import { useState } from "react";
import Dashboard from "./pages/admin/Dashboard";
import ProductPage from "./pages/admin/ProductPage";
import Users from "./pages/admin/Users";
import Profile from "./pages/admin/Profile";
import Overview from "./pages/admin/Overview";
import Orders from "./pages/admin/Orders";
import Category from "./pages/admin/Category";
import CategoryPageWrapper from "./wrapper/CategoryPageWrapper";
import SearchResultsPage from "./pages/SearchResultsPage";

import { CartProvider } from "./utils/CartContext";
import CartPage from "./pages/CartPage";
import PexelsSearch from "./components/pexel/PexelsSearch";
import Settings from "./pages/admin/Settings";
import BrandPage from "./pages/BrandPage";
import Payment from "./pages/admin/Payment";
import ProtectedRoute from "./utils/ProtectedRoute";
import Footer from "./pages/admin/Footer";
import Campaign from "./pages/admin/Campaign";
import Slider from "./pages/admin/Slider";
import Statistic from "./pages/admin/Statistic";
import Report from "./pages/admin/Report";

import ProductDetailPage from "./pages/ProductDetailPage";
import Login from "./components/form/login/login";

function App() {
  const [showModal, setShowModal] = useState(true);
  // const [openSideDrawer, setOpenSideDrawer] = useState(false);
  // const modalHandler = () => {
  //   setShowModal(true);
  // };
  const modalClosed = () => {
    setShowModal(false);
  };
  // const DrawerHandler = () => {
  //   setOpenSideDrawer(true);
  // };
  // const closeDrawer = () => {
  //   setOpenSideDrawer(false);
  // };
  // const arrayzone = [
  //   "Asia/Aden",
  //   "Asia/Aqtau",
  //   "Asia/Baghdad",
  //   "Asia/Barnaul",
  //   "Asia/Chita",
  //   "Asia/Dhaka",
  //   "Asia/Famagusta",
  //   "Asia/Hong_Kong",
  //   "Asia/Jayapura",
  //   "Asia/Kuala_Lumpur",
  //   "Asia/Jakarta",
  // ];
  // const data = [
  //   { id: 1, label: "آیتم ۱" },
  //   { id: 2, label: "آیتم ۲" },
  //   { id: 3, label: "آیتم ۳" },
  //   { id: 4, label: "آیتم ۴" },
  //   { id: 5, label: "آیتم ۱" },
  //   { id: 6, label: "آیتم ۲" },
  //   { id: 7, label: "آیتم ۳" },
  //   { id: 8, label: "آیتم ۴" },
  //   { id: 9, label: "آیتم ۱" },
  //   { id: 10, label: "آیتم ۲" },
  //   { id: 11, label: "آیتم ۳" },
  //   { id: 12, label: "آیتم ۴" },
  //   { id: 1, label: "آیتم ۱" },
  //   { id: 2, label: "آیتم ۲" },
  //   { id: 3, label: "آیتم ۳" },
  //   { id: 4, label: "آیتم ۴" },
  //   { id: 5, label: "آیتم ۱" },
  //   { id: 6, label: "آیتم ۲" },
  //   { id: 7, label: "آیتم ۳" },
  //   { id: 8, label: "آیتم ۴" },
  //   { id: 9, label: "آیتم ۱" },
  //   { id: 10, label: "آیتم ۲" },
  //   { id: 11, label: "آیتم ۳" },
  //   { id: 12, label: "آیتم ۴" },
  // ];
  const dummyProducts = [
    {
      id: 1,
      title: "Wireless Headphones",
      image: "https://via.placeholder.com/200x180?text=Headphones",
      price: 59.99,
      description: "High quality wireless headphones with great sound.",
    },
    {
      id: 2,
      title: "Smart Watch",
      image: "https://via.placeholder.com/200x180?text=Watch",
      price: 79.99,
      description: "A stylish smartwatch to track your activities.",
    },
    {
      id: 3,
      title: "Laptop Stand",
      image: "https://via.placeholder.com/200x180?text=Stand",
      price: 25.5,
      description: "Ergonomic stand to hold your laptop at eye level.",
    },
    {
      id: 4,
      title: "Wireless Mouse",
      image: "https://via.placeholder.com/200x180?text=Mouse",
      price: 19.99,
      description: "Smooth and responsive wireless mouse.",
    },
  ];

  // const handleClick = (item) => {
  //   alert("روی آیتم کلیک شد: " + item.label);
  // };
  const categories = [
    {
      id: 1,
      title: "Laptops",
      image: "https://via.placeholder.com/150?text=Laptops",
    },
    {
      id: 2,
      title: "Smartphones",
      image: "https://via.placeholder.com/150?text=Phones",
    },
    {
      id: 3,
      title: "Home Appliances",
      image: "https://via.placeholder.com/150?text=Home",
    },
    {
      id: 4,
      title: "Gaming",
      image: "https://via.placeholder.com/150?text=Gaming",
    },
  ];

  return (
    <CartProvider>
      <Routes>
        <Route
          path="/"
          element={<Home products={dummyProducts} categories={categories} />}
        />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route
          path="/login"
          element={
            <>
              <Home />
              <Modal show={showModal} modalClosed={modalClosed}>
                <Login />
              </Modal>
            </>
          }
        />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/search" element={<SearchResultsPage />} />
        <Route path="/category/:categoryId" element={<CategoryPageWrapper />} />
        <Route path="/brands/:brandId" element={<BrandPage />} />
        <Route path="/pexel" element={<PexelsSearch />} />

        <Route path="/dashboard/*" element={<Dashboard />}>
          <Route
            index
            element={
              <ProtectedRoute
                allowedRoles={[
                  "admin",
                  "seller",
                  "support",
                  "customer",
                  "pendingSeller",
                ]}
              >
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="overview"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Overview />
              </ProtectedRoute>
            }
          />
          <Route
            path="profile"
            element={
              <ProtectedRoute
                allowedRoles={["admin", "seller", "customer", "pendingSeller"]}
              >
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="orders"
            element={
              <ProtectedRoute allowedRoles={["admin", "seller", "customer"]}>
                <Orders />
              </ProtectedRoute>
            }
          />
          <Route
            path="payments"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Payment />
              </ProtectedRoute>
            }
          />
          <Route
            path="product"
            element={
              <ProtectedRoute allowedRoles={["admin", "seller"]}>
                <ProductPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="category"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Category />
              </ProtectedRoute>
            }
          />
          <Route
            path="users"
            element={
              <ProtectedRoute allowedRoles={["admin", "support"]}>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="reports"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <div>
                  <Report />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="statistic"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <div>
                  <Statistic />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="notification"
            element={
              <ProtectedRoute allowedRoles={["admin", "support"]}>
                <div>Notification</div>
              </ProtectedRoute>
            }
          />
          <Route
            path="help"
            element={
              <ProtectedRoute
                allowedRoles={["admin", "seller", "customer", "support"]}
              >
                <div>Help</div>
              </ProtectedRoute>
            }
          />
          <Route
            path="general"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="footer"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Footer />
              </ProtectedRoute>
            }
          />
          <Route
            path="slider"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Slider />
              </ProtectedRoute>
            }
          />
          <Route
            path="campaign"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Campaign />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </CartProvider>
  );
}
export default App;
